import { render, staticRenderFns } from "./OrganizationSummaryAdmin.vue?vue&type=template&id=06fb14bd&"
import script from "./OrganizationSummaryAdmin.vue?vue&type=script&lang=js&"
export * from "./OrganizationSummaryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports